import { useState } from "react";
import {
  beforeUpload,
  getBase64,
  getEnabledOptions,
  API_URL,
  PRICE_PARSERS,
  renderOptions,
} from "../../utils";
import {
  PlusOutlined,
  PlusSquareFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  Select,
  Radio,
  Upload,
  DatePicker,
  Checkbox,
  Row,
  InputNumber,
  Tooltip,
} from "antd";
import {
  MasterAdminRole,
  CashierRole,
  ManagerRole,
  ChefRole,
} from "../../utils/enums";
import noimage from "../../assets/images/noimage.png";

const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Зураг оруулах</div>
  </div>
);

const loadingButton = (
  <div>
    <LoadingOutlined />
    <div style={{ marginTop: 8 }}>Түр хүлээнэ үү.</div>
  </div>
);

function FormItems({
  props,
  item,
  files,
  setFiles,
  changed,
  setChanged,
  form,
  setInitData,
  setisconnect,
  isconnect,
}) {
  const { pathname } = window.location;
  const [cropImg, setCropImg] = useState(null);
  const [loading, setLoading] = useState(false);

  const renderRadioGroup = (field) => {
    let options = getEnabledOptions(props, field.options);
    return (
      options &&
      options.map((item, i) => (
        <Radio.Button
          key={i}
          value={item[field.fieldNames ? field.fieldNames.value : "value"]}
        >
          {item[field.fieldNames ? field.fieldNames.label : "label"]}
        </Radio.Button>
      ))
    );
  };

  const renderCheckBox = (e) => {
    let tmp = e.map((item, i) => {
      return (
        <Row className="mt-2">
          <Checkbox key={i} value={item.value}>
            {`${item.label}`}
          </Checkbox>
        </Row>
      );
    });
    return tmp;
  };

  const getRules = (item) => {
    if (item.rules) {
      return [
        { message: `${item.label} оруулна уу.`, required: item.required },
        item.rules,
      ];
    }
    return [{ message: `${item.label} оруулна уу.`, required: item.required }];
  };

  const onChangeFile = (e, name) => {
    if (e && e.file && e.file.status) {
      if (e.file.status === "uploading" && !loading) setLoading(true);

      if (e.file.status === "done") {
        if (loading) setLoading(false);
        getBase64(e.file.originFileObj, (imageUrl) => {
          setFiles({
            ...files,
            [`prev${name}`]: imageUrl,
            [name]: e.file.originFileObj,
          });
        });
      }
    } else {
      getBase64(e, (imageUrl) => {
        setFiles({
          ...files,
          [`prev${name}`]: imageUrl,
          [name]: e,
        });
      });
    }
  };

  const changeCropImg = (e) => {
    if (e.file.status === "uploading" && !loading) {
      setLoading(true);
    } else if (e.file.status === "done") {
      if (loading) setLoading(false);
      setCropImg(e.file.originFileObj);
    }
  };

  const selectChanged = (e, { name, isChange }) => {
    if (isChange) {
      if (name === "roletype") {
        form.setFieldsValue({
          permission: setDefaultRole(e),
        });
      } else if (name === "orderid") {
        props
          .request({
            url: `/order/detail/${e}`,
            method: "POST",
            model: "details",
          })
          .then((res) => {
            if (res.success) {
              setInitData(res.data);
            }
          });
      } else if (name === "productid") {
        const prod =
          props.resproductlist && props.resproductlist.find((x) => x.id === e);
        form.setFieldsValue({
          sprice: prod.sprice,
        });
      } else if (name === "storeid") {
        props.request({
          url: `/product/ownproduct/${e}`,
          method: "POST",
          model: "productdropdown",
        });
      } else {
        let prevChanged = { ...changed };
        prevChanged[name] = e;
        setChanged(prevChanged);
      }
    }
  };

  const setDefaultRole = (e) => {
    switch (e) {
      case 1:
        return MasterAdminRole;
      case 2:
        return MasterAdminRole;
      case 3:
        return CashierRole;
      case 4:
        return ManagerRole;
      case 5:
        return ChefRole;
      default:
        return [];
    }
  };

  const getImage = (item) => {
    let url = "";
    if (loading) return loadingButton;
    if (files[`prev${item.name}`]) {
      if (files[`prev${item.name}`].includes("Resource"))
        url = `${API_URL}${files[`prev${item.name}`]}`;
      else url = `${files[`prev${item.name}`]}`;

      return (
        <div className="h-[100px]">
          <img
            src={url ? url : noimage}
            alt="zurag"
            className="w-full h-full object-contain"
          />
        </div>
      );
    }
    return uploadButton;
  };

  const getOptionsArray = (item) => {
    if (item.depends) {
      if (changed[item.depends]) {
        return getEnabledOptions(
          props,
          item[`options_${changed[item.depends]}`],
          item.isenable
        );
      }
    }
    return getEnabledOptions(props, item.options, item.isenable);
  };

  const normalizeType = (value, prevValue, currItem) => {
    if (currItem.normalize === "number") {
      if (value.includes(" ")) {
        if (prevValue) return prevValue;
        return "";
      }
      if (!isNaN(+value)) {
        return value;
      }
      if (prevValue) return prevValue;
      return "";
    }
    return value;
  };

  const onChangeCheckbox = (e) => {
    if (e.target.id === "isconnect") setisconnect(e.target.checked);
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  /* type ийн дагуу ямар контрол зурхыг сонгох хэсэг */
  const getFormItems = (item) => {
    switch (item.type) {
      case "input":
        return (
          <Input
            placeholder={item.label}
            name={item.name}
            type={item.inputType}
            disabled={item.disabled}
            maxLength={item.maxLength}
            showCount={item.showCount}
          />
        );
      case "radiobutton":
        return (
          <Radio.Group optionType="button" placeholder={item.label}>
            {renderRadioGroup(item)}
          </Radio.Group>
        );
      case "select":
        return (
          <Select
            showSearch
            optionFilterProp="children"
            // filterOption={(input, option) => (option?.children?.props?.children[1] ?? '').includes(input)}
            filterOption={(input, option) => {
              if (item.filterOption)
                return (
                  (option?.children?.props?.children[1] ?? "")
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              else
                return (option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase());
            }}
            placeholder={item.label}
            className="w-full"
            disabled={item.name === "subs" ? isconnect : item.disabled}
            mode={item.mode}
            allowClear={item.allowClear}
            onChange={(e) => selectChanged(e, { ...item }, item.isModal)}
          >
            {renderOptions(
              getOptionsArray(item),
              item.fieldNames && item.fieldNames.label,
              item.fieldNames && item.fieldNames.value,
              false,
              item.showImage
            )}
          </Select>
        );
      case "textArea":
        return (
          <Input.TextArea
            placeholder={item.label}
            defaultValue=""
            className={`${item.showCount ? "mb-2" : ""}`}
            showCount={item.showCount}
            maxLength={item.maxLength}
          />
        );
      case "upload":
        return (
          <Upload
            customRequest={dummyRequest}
            listType="picture-card"
            accept="image/png, image/jpeg"
            showUploadList={false}
            onChange={(e) => onChangeFile(e, item.name)}
            beforeUpload={beforeUpload}
          >
            {getImage(item)}
          </Upload>
        );
      case "datepicker":
        return <DatePicker placeholder={item.label} className="w-full" />;
      case "radio":
        return <Radio.Group placeholder={item.label} />;
      case "checkbox":
        return (
          <Checkbox
            disabled={item.disabled}
            onChange={(e) => onChangeCheckbox(e)}
          />
        );
      case "password":
        return (
          <Input.Password
            disabled={pathname.includes("edit") ? true : false}
            placeholder={item.label}
            name={item.name}
          />
        );
      case "checkboxgroup":
        return <Checkbox.Group>{renderCheckBox(item.options)}</Checkbox.Group>;
      case "number":
        return (
          <InputNumber
            placeholder={item.label}
            name={item.name}
            className="w-full"
            maxLength={item.maxLength}
            min={0}
            {...PRICE_PARSERS}
            disabled={item.disabled}
          />
        );
      case "minnumber":
        return (
          <InputNumber
            placeholder={item.label}
            name={item.name}
            className="w-full"
            maxLength={item.maxLength}
            {...PRICE_PARSERS}
            disabled={item.disabled}
          />
        );
      case "onlynumber":
        return (
          <Input
            placeholder={item.label}
            name={item.name}
            className="w-full"
            maxLength={item.maxLength}
            showCount={item.showCount}
            min={0}
            disabled={item.disabled}
          />
        );
      default:
        return <Input placeholder={item.label} />;
    }
  };

  if (item.desc) {
    return (
      <div className="relative">
        {!item.hidden ? (
          <span
            className={`input-top-label ${
              item.type === "checkbox" ? "left-0 p-0" : ""
            }`}
          >
            {item.label}
          </span>
        ) : null}

        <Form.Item className="antd-form-row-custom" hidden={item.hidden}>
          <Form.Item
            valuePropName={item.valuePropName ? item.valuePropName : "value"}
            className={`${item.type === "upload" ? "upload-fit" : ""}`}
            normalize={(value, prevValue) => {
              return normalizeType(value, prevValue, item);
            }}
            rules={[
              { message: `${item.label} оруулна уу.`, required: item.required },
            ]}
          >
            {getFormItems(item)}
          </Form.Item>
          {item.desc && item.type === "upload" ? (
            <span className="text-grey">{item.desc}</span>
          ) : null}
        </Form.Item>
      </div>
    );
  } else {
    return (
      <div className="relative">
        {!item.hidden ? (
          <span
            className={`input-top-label ${
              item.type === "checkbox" ? "left-0 p-0" : ""
            }`}
          >
            {item.label}
          </span>
        ) : null}
        <Form.Item className="antd-custom-row-tooltip" hidden={item.hidden}>
          <Form.Item
            name={item.name}
            initialValue={item.defaultValue}
            valuePropName={item.valuePropName ? item.valuePropName : "value"}
            className={`${item.type === "upload" ? "upload-fit" : ""}`}
            normalize={(value, prevValue) => {
              return normalizeType(value, prevValue, item);
            }}
            rules={getRules(item)}
          >
            {getFormItems(item)}
          </Form.Item>
          {item.linkBtn && (
            <Tooltip title={item.linkTooltip}>
              <PlusSquareFilled
                className="text-primary text-xl px-2"
                onClick={() => {
                  if (item.linkBtn && window.location) {
                    window.location.replace(item.linkBtn);
                  }
                }}
              />
            </Tooltip>
          )}
        </Form.Item>
      </div>
    );
  }
}

export default FormItems;
